import QueryString from 'qs';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function useQueryParam() {
  const query = useLocation();

  return QueryString.parse(query.search.slice(1));
}
